import { render, staticRenderFns } from "./OrganizationMappingView.vue?vue&type=template&id=54b08754"
import script from "./OrganizationMappingView.vue?vue&type=script&lang=js"
export * from "./OrganizationMappingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports